<template>
    <div>
        <div v-if="loading" class="col-12 mt-5 mb-5" v-loading="true"></div>
        <div v-else>
            <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex">
                    <el-radio-group v-model="type">
                        <el-radio-button label="all">All</el-radio-button>
                        <el-radio-button label="accepted">Accepted</el-radio-button>
                        <el-radio-button label="denied">Denied</el-radio-button>
                        <el-radio-button label="errors">Errors</el-radio-button>
                    </el-radio-group>
                    <el-input
                        v-model="filters.name"
                        @keyup.native="filter(true)"
                        style="width: 300px"
                        class="ml-1"
                        placeholder="Filter by name"/>
                    <el-input
                        v-model="filters.confirmationNumber"
                        @keyup.native="filter(true)"
                        style="width: 300px"
                        class="ml-1"
                        placeholder="Filter by registration number"/>
                </div>

                <div>
                    <el-button  v-if="(user.admin || (user.roles && user.roles[this.$route.params.eventId] && user.roles[this.$route.params.eventId].downloadReports))"
                        :loading="downloadingAttendees"
                        @click="downloadAttendees(attendees[type])">
                            <fa icon="download"/>
                    </el-button>
                    <el-button  v-if="(user.admin || (user.roles && user.roles[this.$route.params.eventId] && user.roles[this.$route.params.eventId].downloadReports))"
                        :loading="downloadingAttendeesFromScreen"
                        @click="downloadAttendeesFromScreen(attendees[type])">
                            Download As Shown
                    </el-button>
                </div>
            </div>

            <card>
                <el-table
                    v-if="type === 'errors'"
                    :data="attendees.errors">
                        <el-table-column label="Registration Number">
                            <template slot-scope="props">
                                {{ props.row.registration.confirmationNumber }}
                            </template>
                        </el-table-column>
                        <el-table-column label="Name">
                            <template slot-scope="props">
                                {{ props.row.name }}
                            </template>
                        </el-table-column>
                        <el-table-column label="E-Mail">
                            <template slot-scope="props">
                                {{ props.row.registration | email }}
                            </template>
                        </el-table-column>
                        <el-table-column label="Scanned At">
                            <template slot-scope="props">
                                {{ props.row.createdAt | formatDate }}
                            </template>
                        </el-table-column>
                        <el-table-column label="By">
                            <template slot-scope="props">
                                <span v-if="props.row.by">
                                    {{ props.row.by.email }}
                                </span>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column label="Description">
                            <template slot-scope="props">
                                <span v-if="props.row.description">
                                    {{ props.row.description }}
                                </span>
                            </template>
                        </el-table-column> -->
                        <el-table-column label="Reason">
                            <template slot-scope="props">
                                <span v-if="props.row.reason">
                                    {{ props.row.reason }}
                                </span>
                            </template>
                        </el-table-column>
                </el-table>

                <el-table
                    v-else
                    :data="attendees[type]">
                        <el-table-column label="Registration Number">
                            <template slot-scope="props">
                                {{ props.row.confirmationNumber }}
                            </template>
                        </el-table-column>
                        <el-table-column label="Name">
                            <template slot-scope="props">
                                {{ props.row.name }}
                            </template>
                        </el-table-column>
                        <el-table-column label="E-Mail">
                            <template slot-scope="props">
                                {{ props.row | email }}
                            </template>
                        </el-table-column>
                        <el-table-column :label="type !== 'all' ? 'Checked in At' : 'Registered At'">
                            <template slot-scope="props">
                                <span v-if="type !== 'all'">
                                    <span v-if="props.row.checkinDates && props.row.checkinDates[activityId]">
                                        {{ props.row.checkinDates[activityId] | formatDate }}
                                    </span>
                                    <span v-else></span>
                                </span>
                                <span v-else>
                                    {{ props.row.createdAt | formatDate }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-if="type !== 'all'"
                            label="Method">
                                <template slot-scope="props">
                                    <span v-if="props.row.checkinMethods && props.row.checkinMethods[activityId]">
                                        {{ props.row.checkinMethods[activityId] }}
                                    </span>
                                </template>
                        </el-table-column>
                        <el-table-column
                            v-if="type !== 'all'"
                            label="By">
                                <template slot-scope="props">
                                    <span v-if="props.row.checkinUsers && props.row.checkinUsers[activityId]">
                                        {{ props.row.checkinUsers[activityId] }}
                                    </span>
                                </template>
                        </el-table-column>
                        <el-table-column label="Actions" v-if="(user.admin || (user.roles && user.roles[this.$route.params.eventId] && user.roles[this.$route.params.eventId].checkinActivities))">
                            <template slot-scope="props">
                                <div v-if="type === 'all' && !(props.row.checkinDates && props.row.checkinDates[activityId])">
                                    <el-button
                                        size="mini"
                                        class="mr-1"
                                        @click="checkin(props.$index, props.row, true, 'manual')">
                                            Checkin
                                    </el-button>
                                    <!-- <el-button
                                        size="mini"
                                        class="mr-1"
                                        @click="checkin(props.$index, props.row, false, 'manual')">
                                            Deny
                                    </el-button> -->
                                </div>
                                <router-link :to="{ name: 'attendee', params: { registrationId: props.row._id } }">
                                    <el-button size="mini">
                                        Details
                                    </el-button>
                                </router-link>
                            </template>
                        </el-table-column>
                </el-table>
            </card>

        </div>
    </div>
</template>

<script>
import http from '../../http.js'
import download from 'downloadjs'
import moment from 'moment'
import _ from 'lodash'
import { mapState } from 'vuex'

export default {
    data () {
        return {
            loading: false,
            downloadingAttendees: false,
            downloadingAttendeesFromScreen: false,
            activityId: this.$route.params.activityId,
            type: 'all',
            attendees: {
                data: [],
                all: [],
                denied: [],
                accepted: [],
                errors: []
            },
            filters: {
                name: '',
                confirmationNumber: ''
            }
        }
    },
    computed: {
        ...mapState([
            'user'
        ])
    },
    mounted () {
        if (this.$route.query.checkins) {
            this.type = 'accepted'
        }

        this.getData()
    },
    watch:{
        type(){
            this.loading = true;
            let timer = setTimeout(()=>{
                this.loading = false
                clearTimeout(timer)
            }, 500)
        }
    },
    methods: {
        getData: async function () {
            this.loading = true
            try {
                const [activitiesResponse, erroredResponse] = await Promise.all([
                    http.get(`/api/activities/${this.activityId}`, {
                        params: {
                            withRegisteredAttendees: true,
                            withCheckedInAttendees: true
                        }
                    }),
                    http.get(`/api/checkins`, {
                        params: {
                            filters: {
                                activityId: this.activityId
                            }
                        }
                    })
                ])

                const attendees = activitiesResponse.data.activity.registeredAttendees.filter(attendee => attendee.status !== 'deleted')
                attendees.forEach(attendee => { attendee.name = this.getRegistrationName(attendee) })

                const errors = erroredResponse.data.checkins.map(checkin => {
                    checkin.name = this.getRegistrationName(checkin.registration)
                    return checkin
                })

                this.attendees = {
                    ...this.attendees,
                    data: attendees,
                    all: attendees,
                    accepted: attendees.filter(attendee => attendee.checkinDates && attendee.checkinDates[this.activityId]),
                    denied: attendees.filter(attendee => attendee.deniedCheckins.includes(this.activityId)),
                    allErrors: errors,
                    errors
                }
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error getting errored activities')
            }
            this.loading = false
        },
        getRegistrationName: function (registration) {
            let firstName = registration.fields.find(field => field.fieldMapping === 'firstName')
            firstName = firstName ? firstName.value : ''

            let lastName = registration.fields.find(field => field.fieldMapping === 'lastName')
            lastName = lastName ? lastName.value : ''

            return firstName + ' ' + lastName
        },
        downloadAttendees: async function (attendees) {
            this.downloadingAttendees = true
            let registrationIds = attendees.map(attendee => attendee._id)

            // download errored list
            if (attendees[0] && attendees[0].registration) {
                registrationIds = attendees.map(attendee => attendee.registration._id)
            }

            try {
                const response = await http.post('/api/registrations/download', { registrationIds }, {
                    responseType: 'arraybuffer'
                })
                download(response.data, 'attendees.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error downloading activity attendees')
            }
            this.downloadingAttendees = false
        },
        downloadAttendeesFromScreen: async function (attendees) {
            let data = []
            let fields = []
            if(this.type == 'all'){
                fields = [ 'Registration Number', 'Name', 'E-Mail', 'Registered At' ]
                attendees.forEach(attendee => {
                    const mapping = attendee.fields.find(field => field.fieldMapping === 'email')
                    let email = mapping ? mapping.value : ''
                    let date = moment(attendee.createdAt).format('DD/MM/YYYY HH:mm:ss')
                    data.push([attendee.confirmationNumber, attendee.name, email, date])
                })
            }
            else if(this.type == 'errors'){
                fields = [ 'Registration Number', 'Name', 'E-Mail', 'Scanned At', 'By', 'Reason' ]
                attendees.forEach(attendee => {
                    const mapping = attendee.registration.fields.find(field => field.fieldMapping === 'email')
                    let email = mapping ? mapping.value : ''
                    let date = moment(attendee.createdAt).format('DD/MM/YYYY HH:mm:ss')
                    data.push([attendee.registration.confirmationNumber, attendee.name, email, date, attendee.by ? attendee.by.email : '', attendee.reason ? attendee.reason : ''])
                })

            }
            else{
                fields = [ 'Registration Number', 'Name', 'E-Mail', 'Checked in At' , 'Method', 'By' ]
                attendees.forEach(attendee => {
                    const mapping = attendee.fields.find(field => field.fieldMapping === 'email')
                    let email = mapping ? mapping.value : ''
                    let date = attendee.checkinDates && attendee.checkinDates[this.activityId] ? moment(attendee.checkinDates[this.activityId]).format('DD/MM/YYYY HH:mm:ss') : ''
                    let method = attendee.checkinMethods && attendee.checkinMethods[this.activityId] ? attendee.checkinMethods[this.activityId] : ''
                    let by = attendee.checkinUsers && attendee.checkinUsers[this.activityId] ? attendee.checkinUsers[this.activityId] : ''
                    data.push([attendee.confirmationNumber, attendee.name, email, date, method, by])
                })
            }

            this.downloadingAttendeesFromScreen = true
            try {
                const response = await http.post('/api/registrations/download-from-screen', { fields, data }, {
                    responseType: 'arraybuffer'
                })
                download(response.data, 'attendees.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error downloading activity attendees')
            }
            this.downloadingAttendeesFromScreen = false
        },
        checkin: async function (index, registration, accept, method) {
            try {
                await this.$store.dispatch('checkin', {
                    type: 'activity',
                    id: this.activityId,
                    registrationId: registration._id,
                    accept,
                    method
                })
                this.attendees.all = this.attendees.all.filter(r => r._id !== registration._id)
            } catch (e) {
                console.log(e)
                console.log('error checking in')
            }
        },
        filter: function (debounce = false) {
            const filter = () => {
                const attendees = this.attendees.data.filter(attendee => {
                    if (this.filters.name.length) {
                        return attendee.name.toUpperCase().indexOf(this.filters.name.toUpperCase()) !== -1
                    }
                    if (this.filters.confirmationNumber.length) {
                        return attendee.confirmationNumber == this.filters.confirmationNumber
                    }

                    return attendee
                })

                this.$set(this, 'attendees', {
                    ...this.attendees,
                    all: attendees,
                    accepted: attendees.filter(attendee => attendee.checkinDates && attendee.checkinDates[this.activityId]),
                    denied: attendees.filter(attendee => attendee.deniedCheckins.includes(this.activityId)),
                    errors: this.attendees.allErrors.filter(checkin => {
                        if (this.filters.name.length) {
                            return checkin.name.toUpperCase().indexOf(this.filters.name.toUpperCase()) !== -1
                        }

                        return checkin
                    })
                })
            }

            if (debounce) {
                let delay = _.debounce(() => {
                    filter()
                }, 300)
                delay()
            } else {
                filter()
            }
        }
    },
    filters: {
        formatDate: (date) => moment(date).format('DD/MM/YYYY HH:mm:ss'),
        email: (registration) => {
            let email = ''
            const mapping = registration.fields.find(field => field.fieldMapping === 'email')
            if (mapping) {
                email = mapping.value
            }

            return email
        }
    }
}
</script>